export default __webpack_public_path__ + "static/logo-b1cbd9def4df5eb1828d4172b9868aa9.png";